function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { stableStringify } from "@sail/utils";
import { buildQueryAndVariablesHash } from "../queryUtils/queryAndVariablesHashing";
class ErrorCache {
    setErrors(query, variables, errors) {
        const { documentHashWithVariables: key } = buildQueryAndVariablesHash(query, variables);
        const currentErrors = this.errorMap.get(key);
        if (stableStringify(currentErrors) !== stableStringify(errors)) {
            this.errorMap.set(key, errors);
            this.notifyObservers(key, errors);
        }
    }
    clearErrors(query, variables) {
        const { documentHashWithVariables: key } = buildQueryAndVariablesHash(query, variables);
        if (this.errorMap.has(key)) {
            this.errorMap.delete(key);
            this.notifyObservers(key, null);
        }
    }
    getErrors(query, variables) {
        const { documentHashWithVariables: key } = buildQueryAndVariablesHash(query, variables);
        return this.errorMap.get(key) || null;
    }
    observe(query, variables, observer) {
        const { documentHashWithVariables: key } = buildQueryAndVariablesHash(query, variables);
        if (!this.observers.has(key)) {
            this.observers.set(key, new Set());
        }
        this.observers.get(key).add(observer);
        return ()=>{
            const observers = this.observers.get(key);
            if (observers) {
                observers.delete(observer);
                if (observers.size === 0) {
                    this.observers.delete(key);
                }
            }
        };
    }
    notifyObservers(key, errors) {
        const observers = this.observers.get(key);
        if (observers) {
            observers.forEach((observer)=>observer(errors));
        }
    }
    constructor(){
        _define_property(this, "errorMap", new Map());
        _define_property(this, "observers", new Map());
    }
}
export { ErrorCache as default };

//# sourceMappingURL=ErrorCache.js.map